"use strict";
import { config } from "uniswap/src/config";
import { isWebAndroid, isWebIOS } from "utilities/src/platform";
import { createConnector } from "wagmi";
import { walletConnect } from "wagmi/connectors";
export const WC_PARAMS = {
  projectId: config.walletConnectProjectId,
  metadata: {
    name: "Deli Swap",
    description: "Deli Swap Interface",
    url: "https://www.deliswap.com",
    icons: ["https://www.deliswap.com/favicon.v2.svg"]
  },
  showQrModal: false
};
export function uniswapWalletConnect() {
  return createConnector((config2) => {
    const wc = walletConnect({
      ...WC_PARAMS,
      showQrModal: false
    })(config2);
    config2.emitter.on("message", ({ type, data }) => {
      if (type === "display_uri") {
        const uniswapWalletUri = `https://www.deliswap.com/app/wc?uri=${data}`;
        window.dispatchEvent(new MessageEvent("display_deliswap_uri", { data: uniswapWalletUri }));
        if (isWebIOS || isWebAndroid) {
          window.location.href = `deliswap://wc?uri=${encodeURIComponent(data)}`;
        }
      }
    });
    return {
      ...wc,
      id: "deliswapWalletConnect",
      type: "deliswapWalletConnect",
      name: "Deli Swap Wallet",
      icon: "https://www.deliswap.com/favicon.v2.svg"
    };
  });
}
